import api from "../../Hooks/axiosApi";

/* SEARCHING BY MOBILE FOUND NOBODY.

   11 Oct 2026: on All Leads, 0401 447 743 - a lead that is there - came back "No Lead
   found". The Mobile box shows the number the way it is read, 0401 447 743, and that is
   what was sent to the search. The database holds 0401447743, so a number typed in full
   never matched; only the first four digits did, because they have no space in them.

   The search is sent the digits. What the box shows is unchanged. */
const forSearch = (params: any) =>
    params && typeof params.mobile === "string"
        ? { ...params, mobile: params.mobile.replace(/\D/g, "") }
        : params;

export const getCrmLeadsService = (params: any) => {
    const response = api.get('/api/CrmLeads/GetCrmLeadsByParams', { params: forSearch(params) });
    return response;
};

export const getCrmLeadsPropconnektService = (params: any) => {
    const response = api.get('/api/CrmLeads/GetCrmLeadsByParamsPropconnekt', { params: forSearch(params) });
    return response;
};
export const getCrmLeadsFintrackService = (params: any) => {
    const response = api.get('/api/CrmLeads/GetCrmLeadsByParamsFintrack', { params: forSearch(params) });
    return response;
}; 

export const getCrmLeadsServiceTasklist = (params: any) => {
    const response = api.get('/api/CrmLeads/GetCrmLeadsByParamsTasklist', { params: forSearch(params) });
    return response;
};

export const deleteCrmLeadsService = (leadId: any) => {
    const response = api.delete(`/api/CrmLeads/CrmDeleteLead/${leadId}?deletedBy=system`);
    return response;
};
export const updateCRMLeadsService = async ({ leadID, data }: { leadID: any; data: any }) => {
    return api.put(`/api/CrmLeads/UpdateLead/${leadID}`, data);
};


export const createCRMLeadService = (data: any) => {
    const response = api.post(`/api/CrmLeads/CreateLead`, data);
    return response;
};

export const getCrmLeadsByIdsService = (ids: any) => {
    const response = api.get(`/api/CrmLeads/GetCrmLeadById/${ids}`);
    return response;
};

export const createCRMLeadCommentService = (data: any) => {
    const response = api.post(`/api/CrmLeads/AddLeadComments`, data);
    return response;
};

export const getCRMLeadCommentService = (leadID: any) => {
    const response = api.get(`/api/CrmLeads/GetLeadComments/${leadID}`,);
    return response;
};

export const getCrmDDLService = () => {
    const response = api.get('/api/CrmLeads/GetAllLeadDDL');
    return response;
};

export const getCrmLeadsFactFindService = (leadID: any) => {
    const response = api.get(`/api/CrmLeads/GetFactFindByLeadID/${leadID}`);
    return response;
};

export const getCrmLoanEnquiryService = (leadID: string) => {
    return api.get(`/api/LoanEnquiry/GetCrmLoanEnquiry/${leadID}`);
};

export const getAbnDetails = (abn: string) => {
    return api.get(`/api/Auth/GetAbnDetails`, { params: { abn } });
};

export const updateCrmLoanEnquiryService = (data: any) => {
    return api.post(`/api/LoanEnquiry/updateCrmLoanEnquiry`, data);
};

export const getLoanEnquiryMatchService = (enquiryId: string, productType: string) => {
    return api.get(`/api/LoanEnquiry/GetLoanMatches`, {
        headers: {
            LeadId: enquiryId,
            ProductType: productType
        }
    });
};

export const uploadLeadDocumentService = ({ leadId, file }: { leadId: string; file: File }) => {
    const formData = new FormData();
    formData.append("file", file);

    return api.post(`/api/CrmLeads/UploadleadDocument/${leadId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const getLeadDocumentsService = (leadId: any) => {
    return api.get(`/api/CrmLeads/GetDocumentsByLeadId/${leadId}`);
};

export const deleteLeadDocumentService = (id: any) => {
    return api.delete(`/api/CrmLeads/DeleteDocument/${id}`);
};

export const deleteMultipleLeadsService = (data: any) => {
    return api.delete(`/api/CrmLeads/SoftDeleteLeads?deletedBy=system`,{data});
};

export const updateLeadFollowUpService = ({ date, data }: { date: string; data: any }) => {
    const response = api.put(`/api/CrmLeads/UpdateFollowUp?followUp=${date}`, data);
    return response;
};
export const updateLeadFollowUpService2 = ({ date, data, commentText, staffId }: { date: string; data: any; commentText: string; staffId: number }) => {
    const response = api.put(`/api/CrmLeads/UpdateFollowUp?followUp=${date}&commentText=${encodeURIComponent(commentText)}&staffId=${staffId}`, data);
    return response;
};
export const updateLeadFollowupCommentService = (data : any) => {
    const response = api.post(`/api/CrmLeads/UpdateBulkfollowupcomments`, data);
    return response;
};

export const updateLeadBulkStaffService = (data : any) => {
    const response = api.post(`/api/CrmLeads/UpdateBulkfollowupstaff`, data);
    return response;
};

export const updateFactFindService = (data : any) => {
    const response = api.put(`/api/CrmLeads/UpdateFactfindLead`, data);
    return response;
};

// Discovery Call API services
export const getDiscoveryCallByLeadIdService = (leadId: number) => {
    const response = api.get(`/api/CrmLeads/GetDiscoveryCallByLeadId/${leadId}`);
    return response;
};

export const saveOrUpdateDiscoveryCallService = (data: any) => {
    const response = api.post(`/api/CrmLeads/SaveOrUpdateDiscoveryCall`, data);
    return response;
};

export const sendDocusignService = (leadId: number, docId: number, signedDate: string) => {
    return api.get(`/api/LoanEnquiry/send-docusign`, { params: { leadId, docId, signedDate } });
};

export const getDocusignLogService = (leadId: number) => {
    return api.get(`/api/LoanEnquiry/GetDocuSignEnvelopeLogByLeadId`, { params: { leadId } });
};

// Stage history: every stage change for a lead (who, when, from -> to, days on stage).
export const getLeadStageHistoryService = (leadID: any) => {
    const response = api.get(`/api/CrmLeads/StageHistory/${leadID}`);
    return response;
};

// ---------- The Business Builder agreement (Fintrack's own e-signature) ----------
// Not DocuSign. Sending creates a private link, emails it to the client, and
// cancels any earlier unsigned agreement on the same lead.
export const getLeadAgreementsService = (leadId: number | string) => {
    return api.get(`/api/crm/leads/${leadId}/agreements`);
};

export const sendLeadAgreementService = (
    leadId: number | string,
    body: {
        agreementType?: string;
        companyName?: string | null;
        abn?: string | null;
        acn?: string | null;
        signerName?: string | null;
        signerEmail?: string | null;
        setupFee?: number | null;
        monthlyFee?: number | null;
        termMonths?: number | null;
        inclusions?: string | null;
        sendEmail?: boolean;
    }
) => {
    return api.post(`/api/crm/leads/${leadId}/agreement`, body);
};

export const previewLeadAgreementService = (body: any) => {
    return api.post(`/api/crm/agreements/preview`, body);
};

export const cancelLeadAgreementService = (agreementId: number) => {
    return api.post(`/api/crm/agreements/${agreementId}/cancel`);
};
